/*
HOW TO ADD A NEW PRODUCT WITH ENGRAVING
- make a product without engraving
- make a product with engraving (higher price)
- add a handle to "allHandles"
- add an object to "products" and update handles
- make sure the product has "otto-black" tag or similar (look at setPreviewVars to see all of them)
*/

// FONTS_WITHOUT_EMOJIS = ['Aleo', 'Poppins', 'IvyMode'];

PRODUCT_WITH_ENGRAVING = {
  variantBlack: 'Black',
  variantGrey: 'Grey',
  variantBrick: 'Brick',
  variantSage: 'Sage',
  txt: { 
    enterText: 'First enter your engraving text.'
  }
}

let buttonText1 = 'I WANT MY OTTO PERSONALISED'
let buttonText2 = 'NAH, I WANT MY OTTO WITHOUT ENGRAVING'
let buttonText3 = 'I WANT MY OTTO PERSONALISED FREE OF CHARGE'

if (theme.root == '/sl') {
  PRODUCT_WITH_ENGRAVING = {
    variantBlack: 'Črna',
    variantGrey: 'Siva',
    variantBrick: 'Opečnata',
    variantSage: 'Zelena',
    txt: { 
      enterText: 'Najprej vpiši besedilo za gravuro.'
    }
  }

  buttonText1 = 'MOJ OTTO NAJ BO PERSONALIZIRAN'
  buttonText2 = 'OTTO BREZ GRAVURE BO ČISTO OK'
  buttonText3 = 'MOJ OTTO NAJB BO PERSONALIZIRAN ZASTONJ'  
}

OTTO_PRODUCT = {
  ...PRODUCT_WITH_ENGRAVING,
  allHandles: ['otto-modern-turkish-coffee-pot-engraving', 'polar-goat-bundle-with-engraving', 'you-otto-be-mine-bundle-with-engraving', 'holiday-survival-kit-with-engraving', 'otto-goat-mug-bundle-engraving', 'otto-coffee-bundle-engraving', 'otto-brick-goat-mug-coffee-bundle-engraving', 'otto-sage-goat-mug-coffee-bundle-engraving'],
  products: [
    {
      withoutEngraving: 'otto-modern-turkish-coffee-pot',
      withEngraving: 'otto-modern-turkish-coffee-pot-engraving',
      btnDoPersonalise: buttonText1,
      btnDontPersonalise: buttonText2
    },
    {
      withoutEngraving: 'polar-goat-bundle',
      withEngraving: 'polar-goat-bundle-with-engraving',
      btnDoPersonalise: buttonText1,
      btnDontPersonalise: buttonText2
    },
    {
      withoutEngraving: 'otto-be-mine-bundle',
      withEngraving: 'you-otto-be-mine-bundle-with-engraving',
      btnDoPersonalise: buttonText3,
      btnDontPersonalise: buttonText2
    },
    {
      withoutEngraving: 'holiday-survival-kit',
      withEngraving: 'holiday-survival-kit-with-engraving',
      btnDoPersonalise: buttonText1,
      btnDontPersonalise: buttonText2
    },
    {
      withoutEngraving: 'otto-goat-mug-bundle',
      withEngraving: 'otto-goat-mug-bundle-engraving',
      btnDoPersonalise: buttonText1,
      btnDontPersonalise: buttonText2
    },
    {
      withoutEngraving: 'otto-coffee-bundle',
      withEngraving: 'otto-coffee-bundle-engraving',
      btnDoPersonalise: buttonText1,
      btnDontPersonalise: buttonText2
    },
    {
      withoutEngraving: 'otto-brick-goat-mug-coffee-bundle',
      withEngraving: 'otto-brick-goat-mug-coffee-bundle-engraving',
      btnDoPersonalise: buttonText1,
      btnDontPersonalise: buttonText2
    },
    {
      withoutEngraving: 'otto-sage-goat-mug-coffee-bundle',
      withEngraving: 'otto-sage-goat-mug-coffee-bundle-engraving',
      btnDoPersonalise: buttonText1,
      btnDontPersonalise: buttonText2
    }
  ]
}

CartManager.fixCart = function(cart) {
  cart = CartManager.propertiesToHtml(cart)       // Build properties HTML for the Drawer
  // cart.items = CartManager.addEngravingPriceToProduct(cart.items)
  return cart
}

Engravings.findCurrentFontSize = function(fontName) {
  if (fontName == 'Aleo')
    return '0.5vw'
  else if (fontName == 'Poppins')
    return '0.6vw'    
  else
    return '0.8vw'
}

// this.selector is a jQuery selector that finds engraving img in the resources html
// this.handle is usually used for css and font properties

EngravingView.prototype.initValidator = function() {

  // Engraving is not added to cart if no text.
  // But no warnings are displayed.
  let error1 = new ValidatorError({
      handle: 'no-text',
      classesToAddOnError: '',
      classesToRemoveOnSuccess: '',
      preventPreview: false,
      preventBuy: true,
      isValid: userText => userText.length > 0
  })

  // Make sure words are not too long
  let error2 = new ValidatorError({
    $h: this.$h.find('.error-msg[data-index="1"]'),
    handle: 'not-enough-spaces',
    preventPreview: true,
    preventBuy: true,

    isValid: userText => {
      // Long engraving on body - must not have too many spaces
      if (INLINE_BODY == this.type) return Engravings.formatText(userText, this) != null
    }
  })

  // Detect unsupported characters and emojis
  let $error3msg = this.$h.find('.error-msg[data-index="2"]')
  let error3 = new ValidatorError({
    handle: 'unsupported-characters',
    $h: $error3msg,
    hideMsgOnSuccess: false,
    classesToAddOnError: '',
    classesToRemoveOnSuccess: '',
    preventPreview: false,
    preventBuy: false,
    
    isValid: function(userText) {

      if (Engravings.removeUnsupportedEmojis(userText).unsupportedEmojis.length == 0) return true
       
      // If unsupported emojis were in text, display a warning for 3 sec
      else {
        setTimeout(function() { $error3msg.slideUp() }, 3000)
        return false
      }
    }
  })
 
  this.validatorTextField = new ValidatorField({
      $h: this.$h.find('input.user-text'),
      errors: [error3, error2, error1]
  })
}

EngravingView.prototype.setPreviewVars = function() {

  let { tag, type } = this

  if (OTTO_PRODUCT.allHandles.includes(g_product.handle)) {
    let selectedVariant = g_getSelectedVariant()
    // Bundles: the OTTO colour can be the first part of a multi-option variant title ("Brick / Black, 12 oz ...")
    let svParts = String(selectedVariant || '').split(' / ')
    let isColour = v => selectedVariant == v || svParts[0] == v
    let colourTag = null
    if (isColour(OTTO_PRODUCT.variantBlack)) colourTag = 'otto-black'
    if (isColour(OTTO_PRODUCT.variantGrey)) colourTag = 'otto-grey'
    if (isColour(OTTO_PRODUCT.variantBrick)) colourTag = 'otto-brick'
    if (isColour(OTTO_PRODUCT.variantSage)) colourTag = 'otto-sage'
    // Bundles with a fixed OTTO colour (no colour option): fall back to the product tag
    if (!colourTag) {
      let tags = (g_product && g_product.tags) || []
      if (typeof tags == 'string') tags = tags.split(',').map(t => t.trim())
      colourTag = ['otto-brick', 'otto-sage', 'otto-grey', 'otto-black'].find(t => tags.includes(t)) || null
    }
    if (colourTag) tag = this.tag = colourTag
    this.handle = 'otto'
    this.selector = `[data-engravingtype=${type}] [data-tag=${tag}]`
    this.identTpl = '{tag}'
  }

  else {
    console.log('==== Alert ====: Product type not recognised')
  }

  if (INLINE_BODY == this.type) {
    this.userTextLimit = 60
  }
}

EngravingView.prototype.getPreviewFunction = function() {
  
  let previews = {
    [INLINE_BODY]: Engravings.createInlineBodyEngravingPreview
  }

  return previews[this.type]
}

Engravings.createInlineBodyEngravingPreview = Engravings.createLongBodyEngravingPreview

/*
// This is a hidden button that we need to click secretly when adding to cart.
// On EN page it's different than on SI
Engravings.realATCButtonSelector = 'button[type=submit].add-to-cart.bold_clone'

Engravings.updateATCButton = function() {

  // Clone "Add to cart" button. This one does nothing when you click on it until engraving text is entered.
  Engravings.$atcbtn = $('button[type=submit].add-to-cart').hide()
  Engravings.$atcbtn.after('<div id="atcbtn_ghost" class="btn btn--full add-to-cart cartbutton" style="display: inline-block">' + Engravings.$atcbtn.html() + '</div>' +
                           '<div id="atc-error-msg">'+OTTO_PRODUCT.txt.enterText+'</div>')

$('#atcbtn_ghost').click(function() {
  if (Engravings.AllEngravingForms[0].views[0].isValidated) {
    Engravings.$atcbtn.click()
    // $(Engravings.realATCButtonSelector).click()
  }
  else if (Engravings.AllEngravingForms[0].views[0].userText.length == 0) {
      $('#atc-error-msg').slideDown()
      setTimeout(() => $('#atc-error-msg').slideUp(), 3000)
    }
  })  
}
*/

Engravings.init = function() {
  console.log('init')

  let productWEngraving = OTTO_PRODUCT.products.find(item => item.withEngraving == g_product.handle)

  if (!productWEngraving) return

  // Open the preview and disable the Personalise button
  Engravings.AllEngravingForms.forEach(form => form.show())

  let $form = $('[is="product-form"]')
  $form.append('<div id="engraving-properties"></div><div id="atc-error-msg">'+OTTO_PRODUCT.txt.enterText+'</div>')

  $form.find('button').click(function(e) {
    e.preventDefault()
    if (Engravings.AllEngravingForms[0].views[0].isValidated) {
      Engravings.addEngravingPropertiesToProductForm()
      $form.submit()
    }
    else if (Engravings.AllEngravingForms[0].views[0].userText.length == 0) {
      $('#atc-error-msg').slideDown()
      setTimeout(() => $('#atc-error-msg').slideUp(), 3000)
    }      
  })

  // Update the personalise button
  $('#otto-dont-personalise p').text(productWEngraving.btnDontPersonalise)
  $('#otto-dont-personalise').removeClass('hide').click(() => location = '/products/' + productWEngraving.withoutEngraving)  
}

$(document).ready(function() {

  // Make sure we're on the product page
  if (!g_product) return

   /* 
   When a product has na engraving option, 2 products are created.
   One with and one without the engraving.
   Here both of the product pages are handled.
   */
  
  //
  // Page without engraving
  //
  let productWOEngraving = OTTO_PRODUCT.products.find(item => item.withoutEngraving == g_product.handle)
  
  if (productWOEngraving) {
    Engravings.personaliseButton.$h.off('click')  // We need this, because we're overwriting the code from engravings.js
    $('#otto-personalise p').text(productWOEngraving.btnDoPersonalise)
    $('#otto-personalise').removeClass('hide').click(() => location = '/products/' + productWOEngraving.withEngraving)
  } 
  
  document.addEventListener('variant:change', (e) => {
    const { formId, variant, previousVariant } = e.detail || {};
    Engravings.init()
    Engravings.refreshAll()
  });

  Engravings.init()

})



